import type { ChannelType } from '../channels/channel-types';
import type { ComplianceIssue } from '../channels/compliance';
import type { MediaKind } from '../../content/media/formats';

export enum PublicationStatus {
  Planned = 'planned',
  Due = 'due',
  Published = 'published',
  Cancelled = 'cancelled',
}

export interface PublicationDto {
  id: string;
  blogId: string;
  postId: string;
  postTitle: string;
  channelId: string;
  channelName: string;
  channelType: ChannelType;
  schemeId: string | null;
  stepIndex: number;
  queueItemId: string | null;
  /** null — время не рассчитано (SCH-RULE-2). */
  plannedAt: string | null;
  pinned: boolean;
  status: PublicationStatus;
  publishedAt: string | null;
  externalUrl: string | null;
  note: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PackageMediaDto {
  mediaId: string;
  /** Имя файла в пакете: 01.jpg, 02.mov … */
  fileName: string;
  kind: MediaKind;
  mimeType: string;
  usesRendition: boolean;
  /** Путь API для скачивания файла пакета. */
  downloadPath: string;
  thumbnailPath: string | null;
}

// PUB-UC-2
export interface PublicationPackageDto {
  publication: PublicationDto;
  caption: string;
  droppedTags: string[];
  issues: ComplianceIssue[];
  media: PackageMediaDto[];
  channelUrl: string;
}

// PUB-UC-3
export interface MarkPublishedRequestDto {
  url?: string;
  publishedAt?: string;
}

// PUB-UC-8
export interface RecordPublicationRequestDto {
  channelId: string;
  publishedAt: string;
  url?: string;
}

// PUB-UC-9: переданные поля меняются; пустая ссылка убирает её.
export interface UpdatePublicationRequestDto {
  channelId?: string;
  publishedAt?: string;
  url?: string;
}

// PUB-UC-4
export interface CancelPublicationRequestDto {
  note?: string;
}

export const PUBLICATION_NOTE_MAX_LENGTH = 500;
/** PUB-UC-1.CC-1: комментарий автоматической отмены. */
export const WITHDRAWN_NOTE = 'post-withdrawn';
